/**
 * External dependencies
 */
import {
	withTabbedInspector,
} from '~cartzillagb/higher-order'
import classnames from 'classnames'
import { Fragment } from '@wordpress/element'

/**
 * WordPress dependencies
 */
import { i18n } from 'cartzillagb'
import {
	PanelBody, ToggleControl, RangeControl
} from '@wordpress/components'
import { __ } from '@wordpress/i18n'
import { addFilter, applyFilters } from '@wordpress/hooks'
import { InnerBlocks } from '@wordpress/block-editor'
import { compose } from '@wordpress/compose'

addFilter( 'cartzillagb.container.edit.inspector.style.before', 'cartzillagb/container', ( output, props ) => {
	const { attributes, setAttributes } = props
	const {
		enableContainer,
		enablemaxwidth,
		width,

	} = attributes

	return (
		<Fragment>
			<PanelBody title={ __( "General Settings", i18n ) } initialOpen={ true     }>
				<ToggleControl
					label={ __( 'Enable Container', i18n ) }
					checked={ enableContainer }
					onChange={ enableContainer => setAttributes( { enableContainer } ) }
				/>
				<ToggleControl
					label={ __( 'Enable MaxWidth', i18n ) }
					checked={ enablemaxwidth }
					onChange={ enablemaxwidth => setAttributes( { enablemaxwidth } ) }
				/>
				{ enablemaxwidth &&
					<RangeControl
						label={ __( 'Max Width', i18n ) }
						value={ width }
						onChange={ width => setAttributes( { width } ) }
						min={ 30 }
						max={ 100 }
					/>
				}
			</PanelBody>
		</Fragment>
	)
} )

const edit = props => {
	const {
		className, attributes,
	} = props

	const {
		enableContainer,
		enablemaxwidth,
		width,
	} = attributes

	const mainClasses = classnames( [
		'czgb-container-block',
		className,
		enableContainer ? 'container' : '',
	], applyFilters( 'cartzillagb.container.main-block.classes', {}, props ) )


	const htmlAttr = {}

	if( enablemaxwidth === true ) {
		htmlAttr.style = {
			maxWidth: `${ width }rem`,
		}
	}

	return (
		<div  className={ mainClasses } { ...htmlAttr }>
			<InnerBlocks
				templateLock={ false }
			/>
		</div>
	)  
}

export default compose(
	withTabbedInspector( [ 'style', 'advanced' ] ),
)( edit )